import { interfaceCourseTrackRepository } from "../../../infrastructure/repository/impl/courseTrack_repository";
import { Course, CourseTrack, CourseTrackMandatory } from "../../entities/entities";
import { Order } from "../../entities/order";

interface CourseTrackUseCases {
  get(courseTrackID: number): Promise<CourseTrack>;
  list(): Promise<CourseTrack[]>;
  listBySchool(schoolID: number): Promise<CourseTrack[]>;
  listBySearch(search: string): Promise<CourseTrack[]>;
  listCourseTrackTraining(
    courseTrackID: number,
    index: number
  ): Promise<CourseTrackMandatory>;
  getRequiredCourseTrack(order: Order): Promise<CourseTrack[]>;
}

class _CourseTrackUseCases implements CourseTrackUseCases {
  async get(courseTrackID: number): Promise<CourseTrack> {
    return await interfaceCourseTrackRepository.get(courseTrackID);
  }

  async list(): Promise<CourseTrack[]> {
    return await interfaceCourseTrackRepository.list();
  }

  async listBySchool(schoolID: number): Promise<CourseTrack[]> {
    return await interfaceCourseTrackRepository.listBySchool(schoolID);
  }

  async listBySearch(search: string): Promise<CourseTrack[]> {
    return await interfaceCourseTrackRepository.listBySearch(search);
  }

  async listCourseTrackTraining(
    courseTrackID: number,
    index: number
  ): Promise<CourseTrackMandatory> {
    return await interfaceCourseTrackRepository.listCourseTrackTraining(
      courseTrackID,
      index
    );
  }

  async getRequiredCourseTrack(order: Order): Promise<CourseTrack[]> {
    return await interfaceCourseTrackRepository.getRequiredCourseTrack(order);
  }
}

export const InterfaceCourseTrackUseCases: CourseTrackUseCases = new _CourseTrackUseCases();
